/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.success\":\"Ympyrä, jonka sisällä on valintamerkki\"}");